// Alphabet wise
export const urls = {
    addPlaybookQuestions: 'playbooks/addQuestions/upload',
    chunkEvaluation: 'playbooks/chunkEvaluation',
    completeReview: 'clientSourceList/source-complete-review-submit',
    createPlaybook: 'playbooks/createPlaybook',
    controversyList: 'news-articles/get-news-articles',
    createPlaybookBatch: 'playbook-batches/createPlaybookBatch',
    createPlaybookQuestions: 'playbooks/create-playbook-questions',
    createPortfolio: 'user-portfolio-mapping/create-user-portfolio',
    deleteEntities: 'entities/delete',
    deletePlaybook: 'playbooks/deletePlaybook',
    deleteSource: 'entitySourceLists/deleteSyncedSource',
    deleteUploadedFile: 'clientSourceList/delete-uploaded-doc',
    downloadFailedFile: 'clientSourceList/download-failed-file',
    downloadMetaJson: 'clientSourceList/download-meta-json',
    disclosureTypes: 'playbooks/retrive/playbook-batch-disclosure-types',
    editEntities: 'entities/edit',
    editPlaybookQuestions: 'playbooks/update-delete-questions',
    entityList: 'clientSourceList/get-entity-values/drop-down',
    entityListData: 'clientSourceList/entitylevel-sources-review/overall',
    esgChatControversy: 'controResearch/retrieve/answer',
    esgChat: 'esg_aide/bedrock-answer',
    esgChatDocSearch: 'esg_aide/documentChat',
    esgChatFeedBack: 'esg_aide/answer',
    esgChatFolders: 'esg_aide/custom/fetch-folders',
    esgChatHistory: 'esg_aide/getChatHistory',
    esgChatSignedUrl: 'esg_aide/getSignedUrl',
    esgChatSourceList: 'esg_aide/getSourceList',
    exportMasterQuestions: 'playbooks/export-master-questions',
    esgChatExportSourceList: 'esg_aide/exportSourceList',
    extractVariable: 'clientVariables/extractVariable',
    exportExtraction: 'clientVariableResults/exportBatchResults',
    fetchCompanyList: 'esg_aide/retrieve/companylist',
    fileDelete: 'esg_aide/deleteCustomFiles',
    fileList: 'esg_aide/list-files',
    fileReview: 'clientSourceList/upload-convertedDoc-submit',
    fileUpload: 'esg_aide/fileUpload',
    fileValidation: 'clientSourceList/file-validation-text-split',
    forgotPassword: 'password-resets',
    getEntitiesData: 'clientSourceList/get-client-variables-data',
    getPrioritizedSource: 'playbook-questions',
    importCorrectedFile: 'clientVariableResults/updateResult',
    importMasterQuestions: 'playbooks/createQuestions/upload',
    initiateSync: 'clientSourceList/initiate-move-to-input',
    itemDetails: 'clientSourceList/get-file-Details',
    itemLevelData: 'clientSourceList/get-item-level-filtered-data',
    login: 'auth',
    logout: 'auth/logout',
    manageEntitiesFilter: 'entities/filters',
    optimizePrompt: 'prompt-genie/optimize-prompt',
    otp: 'auth/auth-otp',
    playbookBatchQuestions: 'playbooks/retrive-available/playbook-questions',
    playbookNameDropdown: 'playbooks/playbook-filter-data',
    playbookQuestions: 'esg_aide/playbook-questions',
    playbookSourceYearUpdate: 'playbook-questions/yearUpdate',
    promptFilters: 'clientSourceList/geminiFilters',
    publishTask: 'clientVariables/publish',
    promptGenie: 'prompt-genie/promptGenie',
    questionWiseUpdate: 'playbooks/update/playbook-questions',
    reportExport: 'playbooks/generate-report/bulk-export',
    retrieveAuth: 'auth/callback',
    retrieveEntities: 'entities/export',
    retrieveBatch: 'playbook-batches/retrive-playbook-batch-data',
    retrievePlaybook: 'playbooks/retrive-playbook-data',
    retrievePortfolio: 'esg_aide/retrieve/user-portfolio-companylist',
    requestPlaybooks: 'playbooks/retrive-playbook-entity-master',
    s3Url: 'esg_aide/download',
    signup: 'auth/signup',
    siteDetails: 'customSourceList/retrieveSiteDetails',
    syncNow: 'ingestionjoblogs/custom/syncStart',
    updateDocsData: 'clientSourceList/update-docs-data',
    updateSites: "customSourceList/updateSelectedSite",
    updateSourcePriority: 'playbook-questions/addSourcePriority',
    uploadEntities: 'entities/import',
    userWiseFolderList: 'customSourceList/getUserFolderDetails',
    viewPlaybookQuestions: 'playbooks/retrive-questions-playbookwise',
    viewMetrics: 'clientSourceList/get-client-variables-data/funnel-data',
    optimizePrompt: 'prompt-genie/optimize-prompt',
    getTourList: 'auth/get-pending-tours',
    removeTours: 'auth/remove-tours',
}

const envUrl = {
    dev: '',
    qa: '',
    // uat: "https://esghubdemoapi.esgds.com/",
    // uat: 'https://chatdemoapi.esghub.ai/',
    // uat: 'https://corpapi.esgsure.ai/',
    // uat: "https://platformapi.esgsure.ai/",
    // uat: "https://betaapi.esgsure.ai/",
    uat: "http://localhost:9010/",
    }

const baseUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_ENDPOINT : envUrl.uat

export default baseUrl
